export enum Environment {
  DEVELOPMENT = 'development',
  PRODUCTION = 'live',
  STAGING = 'staging',
  TEST = 'test',
}
